module.exports = __webpack_public_path__ + "img/DressToProgress.cf414bd2.png";